import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import DownloadIcon from "@mui/icons-material/Download";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { Button } from "react-bootstrap";
import DocumentScannerRoundedIcon from "@mui/icons-material/DocumentScannerRounded";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  download_notice_insert_view_log_api,
  show_all_guideline_api,
} from "../api/Users";
import { TablePagination } from "@mui/material";
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Tooltip from '@mui/material/Tooltip'; import
pdfUrl from "../docs/Education MIS System _ Scope of Work.pdf";
import excelURL from "../docs/Dummy_data.xlsx"
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const ViewGuidelines = ({ userData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);


  const openModal1 = () => {
    setIsModalOpen1(true);
  };

  const closeModal1 = () => {
    setIsModalOpen1(false);
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [rows, setRows] = useState([]);
  const iframeRef = React.useRef(null);


  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pdfData, setPdfData] = useState(null);

  const handleFullscreen = () => {
    if (iframeRef.current) {
      const iframeDocument =
        iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document;
      if (iframeDocument.fullscreenElement) {
        document.exitFullscreen();
      } else {
        if (iframeRef.current.requestFullscreen) {
          iframeRef.current.requestFullscreen().catch((err) => {
            console.error(
              `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
            );
          });
        } else if (iframeRef.current.webkitRequestFullscreen) {
          iframeRef.current.webkitRequestFullscreen();
        }
      }
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setIsLoading(true);
    show_all_guideline_api()
      .then((response) => {
        if (response.status == "success") {
          setFilteredData(response.data.result);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching new Guidelines:", error);
      });
  }, []);

  const handleDownload = (row) => {
    console.log(row);
    if (!row || !row.attachment_path) {
      console.error("Attachment path is missing.");
      return;
    }

    const currentDate = new Date()
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

    const path = row.attachment_path;
    const filename = path.split("/").pop();

    const data = {
      notice_id: row.id,
      view_date: currentDate,
      filePath: row.attachment_path,
      fileName: filename,
    };
    download_notice_insert_view_log_api(data)
      .then((response) => {
        if (response.status == "success") {
          toast.success("Notice Downloaded");
        }
      })
      .catch((error) => {
        console.error("Error fetching new Guidelines:", error);
      });
  };

  function openPDFInNewTab(base64String) {
    // Decode Base64 string
    const decodedData = window.atob(base64String);
  
    // Convert to Uint8Array
    const uint8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }
  
    // Create Blob
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
  
    // Create Object URL
    const url = URL.createObjectURL(blob);
  
    // Open in new tab
    window.open(url, '_blank');
  }

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="row my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("All Guidelines")}</h5>

          <div className="Table mb-6">
            <TableContainer
              component={Paper}
              style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
              className="my-4"
            >
              <Table sx={{ minWidth: 800 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{t("Sr. No.")}</TableCell>
                    <TableCell align="left">{t("Guideline")}</TableCell>
                    <TableCell align="left">{t("Issue Date")}</TableCell>
                    <TableCell align="left">{t("View Document")}</TableCell>
                  </TableRow>
                </TableHead>
                {!isLoading && filteredData && filteredData.length > 0 && (
                  <TableBody style={{ color: "white" }}>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row" align="center">
                            {index + 1}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.guideline_text}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {new Date(row.start_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <ListItemAvatar style={{ display: "flex", marginLeft: "2rem" }}>
                              <Avatar>
                                <DocumentScannerRoundedIcon

                                  style={{ cursor: "pointer" }}
                                  onClick={() => openPDFInNewTab(row.attachment_base64)}
                                />
                              </Avatar>
                            </ListItemAvatar>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                )}
                {!isLoading && (!filteredData || filteredData.length === 0) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        <h4>
                          <i>{t("No data available")}</i>
                        </h4>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
      <Modal
        open={isModalOpen1}
        onClose={closeModal1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "70rem",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={closeModal1}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "black",
            }}
          >
            <CloseIcon />
          </IconButton>
          <Tooltip title="Full Screen">
            <IconButton
              aria-label="fullscreen"
              onClick={handleFullscreen}
              sx={{
                position: "absolute",
                right: 48,
                top: 8,
                color: "black",
              }}
            >
              <FullscreenIcon />
            </IconButton>
          </Tooltip>
          <Typography id="modal-modal-title" variant="h6" component="h2">
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
          ></Typography>
          <iframe
            ref={iframeRef}
            allow="fullscreen"
            src={pdfUrl}
            width="100%"
            height="400px"
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button color="secondary" onClick={closeModal1}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewGuidelines;
